import { RoundTripFragment } from 'generated/resources/graphql'

export const getRoundTripDefaultValues = (data?: RoundTripFragment | null) => {
  return {
    roundTrip: data?.mileage?.roundTrip ?? false,
  }
}
